import styled from "styled-components"

export const Icon = styled.div`
  padding: 8px;
  margin: -8px 0;

  align-self: baseline;

  & > svg {
    display: block;
  }
`
